var render = function render(){var _vm=this,_c=_vm._self._c;return _c('service-screen-layout',{attrs:{"parts":_vm.parts},scopedSlots:_vm._u([{key:"usage",fn:function(){return [_c('PrivateMtnApnUsage',{attrs:{"apnUsageNumber":_vm.saleDefinition.definition.usage.apnUsageNumber}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }